import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-recorders-form',
  templateUrl: './transfer-recorders-form.component.html',
  styleUrls: ['./transfer-recorders-form.component.css']
})
export class TransferRecordersFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/transfer/transfer-recorders/transfer-recorders-form/transfer-recorders-form.component.ts